import { Heading2XL, Heading4XL } from "../typography";

import { AccordionFeatureSection } from "./components/sections/AccordionFeatureSection";
import { DarkSection } from "./life_at_verse/components/DarkSection";
import { Footer } from "./footer/NewFooter";
import { Hero } from "./life_at_verse/components/Hero";
import { OfficeGridSection } from "./life_at_verse/components/OfficeGridSection";
import ProviderNavigation from "../ProviderNavigation";
import { TeamsWordsSection } from "./life_at_verse/components/TeamsWordsSection";
import { coreValuesSections } from "./about/config/aboutConfig";

export default function LifeAtVersePage() {
  const coreValuesSectionsWithoutSubtitle = coreValuesSections.map(
    (section) => ({
      ...section,
      subtitle: undefined,
    }),
  );

  return (
    <div className="tw-relative tw-min-h-screen tw-overflow-x-hidden">
      <div className="tw-bg-[#000665] tw-bg-[url('/landing_page_assets/backgrounds/bg4.jpg')] tw-bg-cover tw-bg-top">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-max-w-[1448px] tw-px-[20px]">
          <div className="tw-flex tw-h-full tw-flex-col">
            <Hero />
          </div>
        </div>
      </div>
      <div className="tw-relative tw-mx-auto tw-flex tw-h-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[80px] tw-overflow-hidden tw-px-[24px] tw-py-[56px] min440:tw-gap-y-[120px] min840:tw-px-[76px]">
        <Heading4XL className="tw-my-0 tw-hidden tw-text-center tw-text-blue-dark-3 min440:tw-flex">
          The way we operate comes back to our core values.
        </Heading4XL>
        <Heading2XL className="tw-my-0 tw-text-center tw-text-blue-dark-3 min440:tw-hidden">
          The way we operate comes back to our core values.
        </Heading2XL>
        <AccordionFeatureSection
          sections={coreValuesSectionsWithoutSubtitle}
          imageSrc="/landing_page_assets/about/About2.png"
          hasButton={false}
          className="tw-gap-x-[3em]"
        />
        <OfficeGridSection />
      </div>
      <DarkSection />
      <TeamsWordsSection />
      <Footer
        title="Join "
        titleAccent="our team."
        description="We are looking for talented, driven individuals who are excited to work in a dynamic and innovative environment."
        hasJobOpeningsButton
        isRounded
        hasSquiggle
      />
    </div>
  );
}
